import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import "../../statusIcon.css";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import "../ListDetail.css";
import { loadAffair } from "../../redux/affair/affairActions";
import { formatStatus, getColorFromStatusLabel } from "../../redux/affair/affairStatus";
import AffairStatusIcon from "./AffairStatusIcon";
import { getCurrentFunctionName } from "../../performanceModeManager";
import { Typography } from "@material-ui/core";

const styles = {
	cardActions: {
		padding: 1,
		width: "100%",
		display: "flex",
		flexDirection: "row-reverse",
		justifyContent: "space-between",
		marginTop: "10px",
		paddingLeft: "15px",
	},
	smallButton: {
		width: "130px",
		margin: "0 20px 0 0",
		padding: 0,
	},
	icon: {
		fontSize: 18,
	},
	btnGo: {
		maxHeight: "35px",
	},
};

class AffairListDetail extends Component {
	constructor(props) {
		super(props);

		this.state = {
			startAffairModalOpenned: false,
		};
	}

	displayAffair() {
		this.props.loadAffair(this.props.affair);
		this.props.history.push("/affairs/affair");
		this.props.globalContainer.current.scrollTop = 0
	}

	start() {
		if (this.state.startAffairModalOpenned) {
			this.props.startAffair(
				this.props.affair,
				this.props.activeUser,
				this.props.history
			);
			this.setState({
				startAffairModalOpenned: false,
			});

			this.displayAffair();
		} else {
			this.setState({
				startAffairModalOpenned: true,
			});
		}
	}

	closeStartAffairModal() {
		this.setState({
			startAffairModalOpenned: false,
		});
	}

	render() {
		console.perfLog(getCurrentFunctionName());
		
		return (
			<div className="col-lg-4 col-md-4 col-sm-6 col-12 div-card">
				<div ref={(divRef) => (this.divRef = divRef)}>
					<Card className="col-lg-12 col-md-12 col-sm-12 col-12 card list-detail-card card-margin-top without-side-padding">
						<CardContent
							className="without-padding card-content-left-align"
							onClick={this.displayAffair.bind(this)}
						>
							<div>
								<div className="row">
									<div className="col-lg-12 col-md-12 col-sm-12 col-12 row">
										<div className="without-side-padding blue-text">
											<Typography variant="h6" >
												{this.props.affair.name}
											</Typography>
										</div>
									</div>
								</div>
								<div className="row card-body-margin">
									<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-side-padding span-center-verticaly card-div-border-right">
										<div className="span-center">
											<span>
												{this.props.affair.date_start.format(
													"DD/MM/YYYY"
												)}
											</span>
										</div>
									</div>
									<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-side-padding row">
										<div className="span-center bold">
											<div className="row">
												<AffairStatusIcon state={this.props.affair.state} />
												<span className={"status-icon-color-" + getColorFromStatusLabel(this.props.affair.state)} >
													{formatStatus(this.props.affair.state)}
												</span>
											</div>
										</div>
									</div>
									<div className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
										<div className="col-lg-12 col-md-12 col-sm-12 col-12 row card-divider-div"></div>
										<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-side-padding span-center-verticaly card-div-border-right">
											<div className="span-center">
												<span className="bold">
													{this.props.affair.code ? this.props.affair.code : ""}
												</span>
											</div>
										</div>
										<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-side-padding">
											<div className="span-center bold">
												<span>{this.props.affair.affair_type}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</CardContent>
					</Card>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		activeUser: state.activeUser,
		affairs: state.affairs,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		loadAffair: (affair) => dispatch(loadAffair(affair)),
	};
};

export default compose(
	withRouter,
	withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps)
)(AffairListDetail);
